function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "paapaya_main2",
  transform: "translate(-177.000000, -1165.000000)",
  fill: "#EEEEEE",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-28",
  transform: "translate(149.000000, 767.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-22",
  transform: "translate(19.000000, 389.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(9.000000, 9.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.7695,11 L0.785714286,11 C0.351776268,11 0,10.6482237 0,10.2142857 L0,0.785714286 C0,0.351776268 0.351776268,0 0.785714286,0 L10.2142857,0 C10.6482237,0 11,0.351776268 11,0.785714286 L11,10.2142857 C11,10.6482237 10.6482237,11 10.2142857,11 L7.4855,11 L7.4855,6.73514286 L8.91785714,6.73514286 L9.13235714,5.07335714 L7.48235714,5.07335714 L7.48235714,4.01185714 C7.48235714,3.52628571 7.62221429,3.20257143 8.30657143,3.20257143 L9.19285714,3.20257143 L9.19285714,1.71521429 C8.76587082,1.67030745 8.33676737,1.64853753 7.90742857,1.65 C7.33768049,1.62499602 6.78155701,1.82866281 6.36271429,2.21571429 C5.95207638,2.65782176 5.73806098,3.24742711 5.7695,3.85 L5.7695,5.07571429 L4.334,5.07571429 L4.334,6.73514286 L5.7695,6.73514286 L5.7695,11 Z",
  id: "Path"
}))))));

function SvgIcoFb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11px",
    height: "11px",
    viewBox: "0 0 11 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Facebook") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFb);
export default __webpack_public_path__ + "static/media/ico_fb.db034a2d.svg";
export { ForwardRef as ReactComponent };